import { useRef } from 'react';
import { Icon } from './Icon';
import './HeroDrop.css';

const reducedMotion = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

const MAX_DROPS = 36;
const GRAVITY = 1400; // px/s²

// Throws droplets out of `layer` on ballistic arcs. Imperative on purpose: no React re-render per
// click, every drop removes itself when its animation ends.
function burst(layer, count = 12) {
    if (!layer || !layer.animate || reducedMotion()) return;
    const n = Math.min(count, MAX_DROPS - layer.childElementCount);
    for (let k = 0; k < n; k++) {
        const el = document.createElement('span');
        el.className = 'heroDropParticle';
        const size = 8 + Math.random() * 10;
        el.style.cssText = `width:${size}px;height:${size}px;margin:${-size / 2}px`;

        const angle = (-90 + (Math.random() * 110 - 55)) * (Math.PI / 180); // a fan pointing up
        const speed = 220 + Math.random() * 220;
        const vx = Math.cos(angle) * speed;
        const vy = Math.sin(angle) * speed;
        const life = 0.75 + Math.random() * 0.3;

        const frames = [];
        let prev = null;
        for (let i = 0; i <= 8; i++) {
            const t = (life * i) / 8;
            let rot = (Math.atan2(vy + GRAVITY * t, vx) * 180) / Math.PI - 45; // the tip trails the velocity
            if (prev !== null) { while (rot - prev > 180) rot -= 360; while (rot - prev < -180) rot += 360; }
            prev = rot;
            frames.push({
                offset: i / 8,
                opacity: i < 6 ? 1 : (8 - i) / 3,
                transform: `translate(${vx * t}px, ${vy * t + 0.5 * GRAVITY * t * t}px) rotate(${rot}deg) scale(${i ? 1 : 0.4})`,
            });
        }

        layer.appendChild(el);
        const anim = el.animate(frames, { duration: life * 1000, delay: Math.random() * 90, fill: 'both', easing: 'linear' });
        anim.onfinish = anim.oncancel = () => el.remove();
    }
}

// The round button that leads the headline. Purely playful: a splash of droplets, nothing else.
export function HeroDrop() {
    const layerRef = useRef(null);

    return (
        <span className="heroDropWrap">
            <span className="heroDropLayer" ref={layerRef} aria-hidden="true" />
            <span className="heroDropFloat">
                <button type="button" className="heroDrop" onClick={() => burst(layerRef.current)} aria-label="Make a splash">
                    <Icon name="upload" size={30} strokeWidth={2.2} />
                </button>
            </span>
        </span>
    );
}
